/**
 * External dependencies
 */
import { some } from 'lodash';

/**
 * Internal dependencies
 */
import getConnectionPaymentType from './get-connection-payment-type';
import getEdits from './get-edits';

export default (state, paymentTypeId) => {
    const connectionPaymentTypes = getConnectionPaymentType(state, paymentTypeId);
    const edits = getEdits(state, paymentTypeId);

    if (!edits) {
        return false;
    }
   
    if (!connectionPaymentTypes && edits) {
        return true;
    }

    if (!connectionPaymentTypes) {
        return false;
    }

    const editsDirty = some(edits, (value, key) => {
        return connectionPaymentTypes[key] !== value;
    });

    return editsDirty;
};